import client from '@efex-services/axios';
import { UpdateTermsService, UpdateTermsServiceResponse } from '../types';

const updateTermsByUser = ({
  enterpriseId,
  data,
}: UpdateTermsService): Promise<UpdateTermsServiceResponse> =>
  client.put(`/enterprise/${enterpriseId}/terms-conditions/`, data);

const updateTermsServcice = {
  updateTermsByUser,
};

export default updateTermsServcice;
